import { MapBaseOverlay } from '../overlays';
import { GoogleMap } from './google-map';

export class GoogleMapOverlays {
  private readonly _overlays = new Map<string, MapBaseOverlay>();

  constructor(private readonly _map: GoogleMap) {}

  public add(overlay: MapBaseOverlay): this {
    if (!this.has(overlay)) {
      this._overlays.set(overlay.getId(), overlay);
      overlay.addTo(this._map);

      this._map.fire('overlay:add', overlay);
    }

    return this;
  }

  public remove(overlay: MapBaseOverlay): this {
    if (this.has(overlay)) {
      this._overlays.delete(overlay.getId());
      overlay.remove();
      this._map.fire('overlay:remove', overlay);
    }

    return this;
  }

  public has(overlayIdOrInstance: MapBaseOverlay): boolean {
    const overlayId: string =
      typeof overlayIdOrInstance === 'string' ? overlayIdOrInstance : overlayIdOrInstance.getId();

    return this._overlays.has(overlayId);
  }

  public set(overlayId: string, overlay: MapBaseOverlay): this {
    this._overlays.set(overlayId, overlay);
    return this;
  }

  public clear(): this {
    this._overlays.forEach((o) => this.remove(o));
    return this;
  }

  public changeMap(map: GoogleMap): this {
    this._overlays.forEach((o) => {
      o.remove();
      o.addTo(map);
    });
    return this;
  }
}
